import "./_waiting-slider.scss";

import classNames from "classnames";

interface WaitingSliderProps {
  size?: "full" | "short";
  bgColor?: "helper-blue" | "gray-500";
  customClassName?: string;
}

function WaitingSlider({
  size = "full",
  bgColor = "helper-blue",
  customClassName
}: WaitingSliderProps) {
  return (
    <div
      className={classNames(
        "waiting-slider",
        customClassName,
        `waiting-slider--${size}`,
        `waiting-slider--${bgColor}`
      )}>
      <div className={"waiting-slider__track"} />
    </div>
  );
}

export default WaitingSlider;
